import { useTexts } from 'utils/useTexts';
import Footer from '@components/shared/Footer/Footer';
import EmploymentAndIncomeForm from '@components/EmploymentAndIncomeForm/EmploymentAndIncomeForm';

const EmploymentAndIncome = () => {
  const { t } = useTexts();

  return (
    <>
      <EmploymentAndIncomeForm />

      <Footer text={t('enterLicensePlate.footer.footerText')} />
    </>
  );
};

export default EmploymentAndIncome;
